export enum AdminSearchCriteria {
  LOCATIONADMIN = 'locationadmin',
  USERADMIN = 'useradmin',
}
